import { UserLocale } from '@teetsh/app/src/types/user';
import isSameDay from '@teetsh/app/src/utils/time/isSameDay';
import getMonth from '@teetsh/app/src/utils/time/getMonth';
import { format } from '@teetsh/app/src/utils/time/format';

export function formatPeriodeDates(
  from: Date,
  to: Date,
  locale: UserLocale,
  separator: string = '->',
) {
  if (isSameDay(from, to)) {
    return format(from, locale, 'dd MMM');
  }
  if (getMonth(from) === getMonth(to)) {
    return `${format(from, locale, 'dd')} ${separator} ${format(
      to,
      locale,
      'dd MMM',
    )}`;
  }
  return `${format(from, locale, 'dd MMM')} ${separator} ${format(
    to,
    locale,
    'dd MMM',
  )}`;
}
